import { getSettingShouldDisplayRetrievalAndRankingDebugInfo } from "@faire/retailer/settings/getSettingShouldDisplayRetrievalAndRankingDebugInfo";
import { UserStore } from "@faire/retailer/stores/domain/UserStore";

export const returnRetrievalRankingDebugInfo = () => {
  const userStore = UserStore.get();
  if (!(userStore.isEmployee || userStore.isImpersonating)) {
    return false;
  }
  return getSettingShouldDisplayRetrievalAndRankingDebugInfo();
};
